/**
 * Modulo Vuex de autenticacao.
 *
 * O backend grava httpOnly cookies (`access_token` / `refresh_token`),
 * entao aqui guardamos apenas a representacao publica do usuario para
 * a UI. Persistimos em localStorage para sobreviver a reloads.
 */

const STORAGE_KEY = 'auth.currentUser';

const readStoredUser = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_e) {
    return null;
  }
};

export const state = {
  currentUser: readStoredUser(),
};

export const mutations = {
  SET_CURRENT_USER(stateObj, user) {
    stateObj.currentUser = user || null;
    try {
      if (user) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
        if (user.id) localStorage.setItem('userid', String(user.id));
      } else {
        localStorage.removeItem(STORAGE_KEY);
        localStorage.removeItem('userid');
      }
    } catch (_e) { /* ignore quota errors */ }
  },
};

export const getters = {
  loggedIn(stateObj) {
    return !!stateObj.currentUser;
  },
  currentUser(stateObj) {
    return stateObj.currentUser;
  },
};

export const actions = {
  setCurrentUser({ commit }, user) {
    commit('SET_CURRENT_USER', user);
  },
  clearCurrentUser({ commit }) {
    commit('SET_CURRENT_USER', null);
  },
};
